<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<!-- 버전 -->
				<sf-select-group
					:label="getMessage_('SWCC000330')"
					:inputValue="ver"
					:options="vers"
					:onChange="value => onChangeSelect('ver', value)"
				/>
			</el-col>
			<el-col :span="5">
				<!-- 구분 -->
				<sf-select-group
					:label="getMessage_('SWCC000844')"
					:inputValue="category"
					:options="categorys"
					:onChange="value => onChangeSelect('category', value)"
				/>
			</el-col>
			<el-col :span="5">
				<!-- 상세구분 -->
				<sf-select-group
					:label="getMessage_('SWCC000845')"
					:inputValue="dtlCategory"
					:options="dtlCategorys"
					:onChange="value => onChangeSelect('dtlCategory', value)"
				/>
			</el-col>
			<el-col :span="5">
				<!-- 키워드 -->
				<sf-input-group
					:label="getMessage_('SWCC000894')"
					:inputValue="kwd"
					placeholder="제목, 내용, 작성자"
					:onChange="value => onChange('kwd', value)"
				/>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line icon="search" v-if="isButton_(scrId, 'CR')" :onClick="search">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/GuideBoard/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);

		// this.plantCd = this.user.plantCd;

		this.getVersion_().catch(error => {
			this.$sf_toast({ type: 'error', message: error.message });
		});
		// this.getCategory_().catch(error => {
		// 	this.$sf_toast({ type: 'error', message: error.message });
		// });
		this.getDtlCategory_().catch(error => {
			this.$sf_toast({ type: 'error', message: error.message });
		});
	},

	watch: {
		screen() {
			if (this.screen.defaultPageSize && this.user.plantCd) {
				this.defaultAssign_({
					key: 'groups',
					value: { currentPage: 1, pageUnit: Number(this.screen.defaultPageSize), data: [] }
				})
					.then(() => {
						this.search();
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					});
			}
		}
	},

	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		search() {
			this.$sf_toggleLoading(true);
			this.getGuideBoardList_({
				ver: this.ver,
				category: this.category,
				dtlCategory: this.dtlCategory,
				kwd: this.kwd,
				currentPage: 1,
				pageUnit: this.groups.pageUnit
			})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		onChangeSelect(key, value) {
			this.defaultAssign_({ key, value });
			this.search();
		},

		onChange(key, value) {
			this.defaultAssign_({ key, value });
		}
	}
};
</script>
<style></style>
